module.exports = __webpack_public_path__ + "static/media/arrow-upward.6b025de9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/arrow-upward.svg
// module id = 1510
// module chunks = 0